import { render, staticRenderFns } from "./resident-data.vue?vue&type=template&id=04027c6a&scoped=true"
import script from "./resident-data.vue?vue&type=script&lang=js"
export * from "./resident-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04027c6a",
  null
  
)

export default component.exports